export default "__VITE_ASSET__CWY8jVJ6__"